/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Col_NoteInputs */

const vi_product_lot_history_col_note = /** @type {(inputs: Product_Lot_History_Col_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu`)
};

/**

* @param {Product_Lot_History_Col_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_col_note = /** @type {((inputs?: Product_Lot_History_Col_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Col_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_col_note(inputs)
});